<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0a8 8 0 1 1 0 16H.8a.8.8 0 0 1-.566-1.366l1.572-1.57A8 8 0 0 1 8 0zm0 6.4a1.201 1.201 0 1 0 1.2 1.2c0-.661-.539-1.2-1.2-1.2zm-3.6 0a1.201 1.201 0 0 0 0 2.4 1.201 1.201 0 0 0 0-2.4zm7.2 0a1.201 1.201 0 1 0 1.2 1.2c0-.663-.539-1.2-1.2-1.2z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
